import { $ as e, F as t, J as n, L as r, M as i, N as a, U as o, _ as s, at as c, f as l, h as u, i as d, k as f, m as p, nt as m, ot as h, p as g, rt as _, t as v, u as y, v as b, w as x } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { r as S, t as C } from "./normalize-props-DNjMoRjC.js";
//#region src/webcomponents/clickable-image/ClickableImage.ce.vue?vue&type=script&setup=true&lang.ts
var w = { class: "container" }, T = [
	"aria-label",
	"onMouseenter",
	"onFocusin",
	"onClick"
], E = 10, D = d(/* @__PURE__ */ v(/* @__PURE__ */ x({
	__name: "ClickableImage.ce",
	props: {
		image: { type: Object },
		areas: { type: Array }
	},
	setup(d, { expose: v }) {
		let x = o("image"), S = e(1), C = new ResizeObserver(() => D());
		function D() {
			x.value.naturalWidth && (S.value = x.value.offsetWidth / x.value.naturalWidth);
		}
		i(() => {
			C.observe(x.value);
		}), a(() => {
			C.disconnect();
		});
		let O = d.areas.some(({ spot: e }) => !!e), k = p(() => d.areas.map((e) => ({
			...e,
			coords: A(e.coords),
			spot: j(e.spot)
		})));
		function A(e) {
			return {
				x1: e.x1 * S.value,
				y1: e.y1 * S.value,
				x2: e.x2 * S.value,
				y2: e.y2 * S.value
			};
		}
		function j({ x: e = 0, y: t = 0 } = {}) {
			return {
				x: e * S.value,
				y: t * S.value
			};
		}
		let M = e();
		function N(e) {
			M.value = e;
		}
		function P() {
			M.value = void 0;
		}
		let F = e();
		function I(e) {
			F.value = e;
		}
		function L() {
			F.value = void 0;
		}
		let R = p(() => F.value ?? M.value), z = p(() => {
			if (R.value !== void 0) return k.value[R.value];
		}), B = p(() => {
			if (!z.value) return {};
			let { tooltipPosition: e, coords: { x1: t, y1: n, x2: r, y2: i } } = z.value;
			switch (e) {
				case "top": return {
					left: `${t + (r - t) / 2}px`,
					transform: "translate(-50%, -100%)",
					top: `${n - E}px`
				};
				case "bottom": return {
					left: `${t + (r - t) / 2}px`,
					transform: "translateX(-50%)",
					top: `${i + E}px`
				};
				case "left": return {
					left: `${t - E}px`,
					top: `${n + (i - n) / 2}px`,
					transform: "translate(-100%, -50%)"
				};
				default: return {
					left: `${r + E}px`,
					top: `${n + (i - n) / 2}px`,
					transform: "translateY(-50%)"
				};
			}
		});
		function V() {
			F.value = void 0;
		}
		return v({ reset: V }), (e, i) => (t(), b("div", w, [
			u("img", f(d.image, {
				ref: "image",
				alt: "",
				onLoad: i[0] ||= (e) => D(),
				onClick: i[1] ||= (e) => L()
			}), null, 16),
			(t(!0), b(g, null, r(k.value, (e, n) => (t(), b("button", {
				key: n,
				style: c({
					"--y1": `${e.coords.y1}px`,
					"--y2": `${e.coords.y2}px`,
					"--x1": `${e.coords.x1}px`,
					"--x2": `${e.coords.x2}px`
				}),
				class: "area",
				"aria-label": e.info,
				onMouseenter: (e) => N(n),
				onMouseleave: i[2] ||= (e) => P(),
				onFocusin: (e) => N(n),
				onFocusout: i[3] ||= (e) => P(),
				onClick: l((e) => I(n), ["stop"])
			}, [m(O) ? (t(), b("span", {
				key: 0,
				class: _(["spot", { active: R.value === n }]),
				style: c({
					"--s-x": `${e.spot.x}px`,
					"--s-y": `${e.spot.y}px`
				})
			}, null, 6)) : s("", !0)], 44, T))), 128)),
			n(u("p", {
				class: "tooltip",
				"aria-hidden": "true",
				style: c(B.value)
			}, h(z.value?.info), 5), [[y, z.value]])
		]));
	}
}), [["styles", ["*{color:#253858;font-family:Nunito,Roboto,sans-serif}.container{border:1px solid #ccc;max-width:100%;position:relative}.container img{width:100%;height:auto;display:block}.container .area{cursor:pointer;top:var(--y1);left:var(--x1);height:calc(var(--y2) - var(--y1));width:calc(var(--x2) - var(--x1));background:0 0;border:none;position:absolute}.container .spot{cursor:pointer;aspect-ratio:1;width:32px;transform:translate(calc(-50% + var(--s-x)), calc(-50% + var(--s-y)));background:#212a3799;border:4px solid #edeff3;border-radius:50%;position:absolute;top:50%;left:50%}.container .spot.active{border-color:#6495ed}.container .tooltip{color:#fff;z-index:10;background-color:#000000d9;border-radius:6px;max-width:260px;padding:8px 12px;font-size:14px;position:absolute}"]]]));
D.prototype.normalizeProps = (e) => ({
	...e,
	image: {
		...e.image,
		height: C(e.height),
		width: C(e.width),
		areas: e.areas.map((e) => ({
			...e,
			tooltipPosition: S(e.tooltipPosition)
		}))
	}
}), window.customElements.define("clickable-image", D);
//#endregion
